import { useResponsive } from "./ResponsiveContext";

export function ResponsiveToolbar() {
  const {
    mode,
    autoMode,
    overrideMode,
    setOverrideMode,
    previewEnabled,
    setPreviewEnabled
  } = useResponsive();

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        padding: 6,
        background: "#fff",
        borderBottom: "1px solid #ddd",
        position: "sticky",
        top: 0,
        zIndex: 100,
        alignItems: "center"
      }}
    >
      {/* Preview Toggle */}
      <button
        onClick={() => setPreviewEnabled(prev => !prev)}
        style={{
          padding: "6px 12px",
          borderRadius: 4,
          border: "1px solid #999",
          background: previewEnabled ? "#1A73E8" : "#f3f3f3",
          color: previewEnabled ? "#fff" : "#000",
          cursor: "pointer"
        }}
      >
        {previewEnabled ? "Preview ON" : "Preview OFF"}
      </button>

      {/* Mode Buttons */}
      {["desktop", "tablet", "mobile"].map(m => (
        <button
          key={m}
          disabled={!previewEnabled}
          onClick={() => setOverrideMode(m)}
          style={{
            padding: "6px 12px",
            borderRadius: 4,
            border: m === mode ? "2px solid #1A73E8" : "1px solid #999",
            background: m === mode ? "#E8F0FE" : "#fff",
            cursor: previewEnabled ? "pointer" : "not-allowed",
            opacity: previewEnabled ? 1 : 0.5
          }}
        >
          {m}
        </button>
      ))}

      {/* Auto Mode Indicator */}
      {!previewEnabled && (
        <span style={{ marginLeft: 10, fontSize: 12, color: "#666" }}>
          Auto: {autoMode}
        </span>
      )}
    </div>
  );
}